import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type { IContractorDeductionTemplate } from "../getContractorDeductionTemplates/getContractorDeductionTemplates";
import { EDeductionType } from "@zeal/common";

export interface ICreateContractorDeductionTemplateRequest {
  companyID: string;
  contractorID: string;
  deduction_type:
    | typeof EDeductionType.GARNISHMENT
    | typeof EDeductionType.MISCELLANEOUS;
  custom_name?: string;
  effective_start_date: string;
  effective_end_date?: string;
  contractor_contribution_amount?: number;
  contractor_contribution_percentage?: number;
  deduction_credit?: boolean;
  agency_address?: string;
  agency_name?: string;
  case_id?: string;
  order_number?: string;
  external_id?: string;
  document?: string;
}

export const createContractorDeductionTemplate = (axios: IAxiosInstance) => {
  return async (
    params: ICreateContractorDeductionTemplateRequest
  ): Promise<IContractorDeductionTemplate> => {
    const response = await axios.noRetry.post<
      IApiResponse<IContractorDeductionTemplate>
    >(`/api/contractor-deduction-templates`, params);
    const data = response.data;

    if (data.success) {
      return data.data;
    }

    throw new Error("Failed to create contractor deduction template");
  };
};
